module.exports = __webpack_public_path__ + "static/img/homebg.bc65bc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homebg.png
// module id = +6qt
// module chunks = 3